import auth from '@/router/middlewares/auth.js';

export default [
  {
    path: '/project/:projectID',
    name: 'ProjectIndex',
    redirect: { name: 'Project-Creator-Details' },
    component: () => import('@/pages/project/index.vue'),
    meta: {
      layout: 'AuthenticatedLayout',
      middleware: [auth],
    },
    children: [
      {
        path: '/project/:projectID/creators/:viewID?/:viewName?',
        name: 'Project-Creator-Details',
        component: () => import('@/pages/project/Details.vue'),
      },
      {
        path: '/project/:projectID/deliverables/:viewID?/:viewName?',
        name: 'Project-Deliverables',
        component: () => import('@/pages/project/Deliverables.vue'),
      },
      {
        path: '/project/:projectID/documents/:viewID?/:viewName?',
        name: 'Project-Documents',
        component: () => import('@/pages/project/Documents.vue'),
      },
      {
        path: '/project/:projectID/album/:albumId',
        name: 'Project-Album',
        component: () => import('@/pages/project/album.vue'),
      },
      {
        path: '/project/:projectID/products',
        name: 'Project-Products',
        component: () => import('@/pages/project/Products.vue'),
      },
      {
        path: '/project/:projectID/content',
        name: 'Project-Content',
        component: () => import('@/pages/project/Content.vue'),
      },
      {
        path: '/project/:projectID/upload',
        name: 'Project-Media-Upload-Index',
        component: () => import('@/pages/project/mediauploader/index.vue'),
        redirect: { name: 'Project-Media-Upload-Deliverables-List' },
        children: [
          {
            path: '/project/:projectID/upload/deliverables',
            name: 'Project-Media-Upload-Deliverables-List',
            component: () => import('@/pages/project/mediauploader/deliverables.vue'),
          },
          {
            path: '/project/:projectID/upload/:deliverableId',
            name: 'Project-Media-Upload-Deliverable',
            component: () => import('@/pages/project/mediauploader/uploadDelierableAssets.vue'),
          },
          {
            path: '/project/:projectID/upload/:deliverableId/edit',
            name: 'Project-Media-Upload-Deliverable-Edit',
            component: () => import('@/pages/project/mediauploader/editDeliverableAssets.vue'),
          },
        ],
      },
    ],
  },
  // {
  //   path: '/project/:projectID/upload',
  //   name: 'Project-Media-Upload',
  //   component: () => import('@/pages/project/mediauploader/index.vue'),
  //   meta: {
  //     layout: 'AuthenticatedLayout',
  //     middleware: [auth],
  //   },
  // },
];
